import react, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import RowInProgress from "./InProgressRow";
import jMoment from "moment-jalaali";
const InProgressTable = (props) => {
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    props.getPage(value);
  };

  return (
    <>
      <TableContainer aria-label="simple table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" />
              <TableCell align="center">شماره جعبه</TableCell>
              <TableCell align="center">تاریخ شروع</TableCell>
              <TableCell align="center">نام بیمار</TableCell>
              <TableCell align="center">نام پزشک</TableCell>
              <TableCell align="center">نوع کار</TableCell>
              <TableCell align="center">آخرین ورود</TableCell>
              <TableCell align="center">پیش بینی خروج</TableCell>
              <TableCell align="center">وضعیت</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((order) => {
              return (
                <RowInProgress
                  key={order.id}
                  orderId={order.id}
                  startDate={jMoment(Number(order.startDate)).format(
                    "jYY/jMM/jDD"
                  )}
                  boxNumber={order.boxNumber}
                  patientName={order.patientName}
                  doctorName={order.doctorName}
                  orderType={order.orderType}
                  lastEntrance={jMoment(Number(order.lastEntry)).format(
                    "jYY/jMM/jDD"
                  )}
                  exitPrediction={
                    order.predictionDate
                      ? jMoment(Number(order.predictionDate)).format(
                          "jYY/jMM/jDD"
                        )
                      : "در انتظار"
                  }
                  condition={order.predictionDate ? order.delation : "inQuee"}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        sx={{ mt: 4, justifyContent: "center", display: "flex" }}
        count={props.pageCount}
        // page={page}
        onChange={handleChange}
      />
    </>
  );
};

export default InProgressTable;
